import React, { useState } from "react";

import Modal from "../../../components/modal/Modal";
import Input from "../../../components/form-item/Input";

/**
 * ページ名の変更モーダル。本文を持たないイメージボードは編集画面が無いため、
 * 3 点リーダーの「リネーム」からここで名前だけを変える
 * （共有ライブラリのファイル名変更と同じ見た目）。
 */

interface NoteRenameModalProps {
  initialTitle: string;
  saving?: boolean;
  onSave: (title: string) => void;
  onClose: () => void;
}

const NoteRenameModal: React.FC<NoteRenameModalProps> = ({
  initialTitle,
  saving = false,
  onSave,
  onClose,
}) => {
  const [draft, setDraft] = useState(initialTitle);
  const trimmed = draft.trim();
  const canSave = !!trimmed && trimmed !== initialTitle;

  const confirm = () => {
    if (canSave && !saving) onSave(trimmed);
  };

  return (
    <Modal
      title="名前を変更"
      titleSize="medium"
      onClose={onClose}
      primaryAction={{
        label: "保存",
        onClick: confirm,
        loading: saving,
        disabled: !canSave,
      }}
      secondaryAction={{ label: "キャンセル", onClick: onClose }}
    >
      {/* Enter で保存する（IME 変換確定の Enter では submit されない） */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          confirm();
        }}
      >
        <Input value={draft} onChange={(e) => setDraft(e.target.value)} />
      </form>
    </Modal>
  );
};

export default NoteRenameModal;
